import '@stoplight/elements-dev-portal/styles.min.css'

import { FunctionComponent } from 'react'
import { PAYMENTS_API_V2_SLUG } from 'src/constants'
import { StoplightProject } from '@stoplight/elements-dev-portal'

const PaymentsAPIV2Docs: FunctionComponent = () => {
  return (
    <>
      <StoplightProject
        basePath={PAYMENTS_API_V2_SLUG}
        projectId={process.env.REACT_APP_STOPLIGHT_PAYMENTS_API_V2_ID || ''}
      />
    </>
  )
}

export default PaymentsAPIV2Docs
